
  import Vue from 'vue'

  import ReadingInfoDialog from '@/components/entities/reading/ReadingInfoDialog.vue';
  import ReadingEditDialog from '@/components/entities/reading/ReadingEditDialog.vue';
  import ReadingDeleteDialog from '@/components/entities/reading/ReadingDeleteDialog.vue';
  import ReadingRestoreDialog from '@/components/entities/reading/ReadingRestoreDialog.vue';

import ReadingService from '@/services/ReadingService';

  export default Vue.extend({
    name: 'ReadingsTable',

    components: {
      ReadingDeleteDialog,
      ReadingInfoDialog,
      ReadingEditDialog,
      ReadingRestoreDialog
    },
    props: ['pagination', 'readingsPage', 'loading'],
    data: (vm: any): any => ({
      tableLoadingText: vm.loadingDataText,
      showUUIDs: false,
      sortDesc: true,
      sortBy: "timestamp",
      selectedHeaders: [
          { text: vm.$t('attribute.timestamp'), value: 'timestamp', index: 200 },
          { text: vm.$t('attribute.value'), value: 'value', sortable: false, index: 300},
          { text: vm.$t('attribute.updatedAt'), value: 'updatedAt', index: 1000 },
          { text: vm.$t('attribute.createdAt'), value: 'createdAt', index: 1100 },
      ],
      currentItems: [],
      loadingDevices: false
    }),
    async created() {
      if(this.readingsPage.length === 0) {
        this.tableLoadingText = this.$t('reading.noData');
      }

      const columns = this.$root.$store.getters.selectedColumns('reading');
      if(columns) {
        this.selectedHeaders = columns;
      }
    },
    watch: {
      selectedHeaders() {
        this.$store.commit("setSelectedColumns", { type: 'reading', columns: this.selectedHeaders });
      } 
    },
    methods: {
      onExport() {
        this.$emit("export");
      },  
      onCurrentItemsChange(items: any[]) {
        this.currentItems = items;
      },
      onReload() {
        this.$emit("reload");
      },
      onSort() {
        // Reset the timestamp sorting if changed, as sorted is done in backend
        setTimeout(() => { this.sortDesc = true; }, 1); // ML: needed for some reason to react
      },
      onReadingItemRestore(item: any) {
        this.$emit("restore", item);
      },
      onReadingItemUpdate(item: any) {
        this.$emit("update", item);
      },
      onReadingItemDelete(item: any) {
        this.$emit("delete", item);
      },
      onTableRowClick(row: any) {
        const button: any = this.$refs["readingInfoButton_" + row.uuid];
        // $el needed for native elements
        button.$el.click();
      },      
      getDeviceUnitLabel(item: any) {
        if(!('device' in item) && !this.loadingDevices) {
          this.loadCurrentDevices(item);
        }

        return item?.device?.unit || item.deviceId;
      },
      getDeviceDescriptionLabel(item: any) {
        if(!('device' in item) && !this.loadingDevices) {
          this.loadCurrentDevices(item);
        }

        return item?.device?.description;
      },
      getDeviceAksLabel(item: any) {
        if(!('device' in item) && !this.loadingDevices) {
          this.loadCurrentDevices(item);
        }

        return item?.device?.aksId;
      },
      async loadCurrentDevices() {
        if(!this.loadingDevices && this.currentItems.length > 0) {
          this.loadingDevices = true;
          let promises: Promise<any>[] = [];
          this.currentItems.forEach(async (reading: any) => {
            if(!('device' in reading))
              promises.push(this.loadDevice(reading));
          });
          await Promise.all(promises);
          this.loadingDevices = false;
        }
      }, 
      async loadDevice(item: any) {
        try {
            const device = await ReadingService.getAssociatedDevice(this.currentTenant, item.uuid);
            Vue.set(item, 'device', device); // important else DOM is not updated
        } catch(err: any) {
            console.log(err);
            console.log(err.response);
            Vue.set(item, 'device', {});
        }
      },
    },
    computed: {
      headers() {
        return [
          { text: this.$t('attribute.uuid'), value: 'uuid', index: 0 },
          { text: this.$t('entity.device') + ' ' + this.$t('attribute.aksId'), value: 'device.aksId', index: 100 },
          { text: this.$t('entity.device')+ ' ' + this.$t('attribute.description'), value: 'device.description', index: 101 },
          { text: this.$t('entity.device')+ ' ' + this.$t('attribute.unit'), value: 'device.unit', index: 102 },
          { text: this.$t('attribute.timestamp'), value: 'timestamp', index: 200 },
          { text: this.$t('attribute.value'), value: 'value', sortable: false, index: 300},
          { text: this.$t('attribute.flag'), value: 'flag', sortable: false, index: 333},
          { text: this.$t('attribute.updatedAt'), value: 'updatedAt', index: 1000 },
          { text: this.$t('attribute.createdAt'), value: 'createdAt', index: 1100 },
          { text: this.$t('attribute.deletedAt'), value: 'deletedAt', index: 1200 },
        ];
      },
      exportTooltipColor(): any {
        return this.exportEnabled ? "" : "error";
      },
      exportEnabled(): boolean {
        return this.pagination.itemsLength < 100000;
      },
      tableFooterProps(): any {
        return {
          'items-per-page-options': [5, 10, 15, 30],
          'items-per-page-text': this.$t('itemsPerPageText'),
        };
      },
      currentTenant(): any {
        return this.$root.$store.state.session.selectedTenant.uuid;
      },
      loadingDataText(): any {
        return this.$t('loadingData');
      },
      computedTableHeader(): any {
        return [...this.selectedHeaders,
          { text: this.$t('attribute.actions'), value: 'actions', sortable: false, filterable: false, index: 9998 },
        ].sort((a: any, b: any) => a.index-b.index);
      },
      canUpdate(): any {
        if (this.$root.$store.state.session.permissions.resources && 'readings' in this.$root.$store.state.session.permissions.resources) {
          return this.$root.$store.state.session.permissions.resources['readings'].includes('PATCH');
        } else {
          return false;
        }
      },
      canCreate(): any {
        if (this.$root.$store.state.session.permissions.resources && 'readings' in this.$root.$store.state.session.permissions.resources) {
          return this.$root.$store.state.session.permissions.resources['readings'].includes('POST');
        } else {
          return false;
        }
      },
      canDelete(): any {
        if (this.$root.$store.state.session.permissions.resources && 'readings' in this.$root.$store.state.session.permissions.resources) {
          return this.$root.$store.state.session.permissions.resources['readings'].includes('DELETE');
        } else {
          return false;
        }
      },
    },
  })
